import React from "react";
import "../Usuarios/usuarios.css";
import { SubSections } from "../../data/navItem";
import CobranzaAsociados from "./CobranzaAsociados";
//TODO QUITAR import CobranzaHistorial from "./CobranzaHistorial";
import CobranzaConciliacion from "./CobranzaConciliacion";
import CobranzaDashboard from "../Productos/CobranzaDashboard";
import CobranzaReestructura from "./CobranzaReestructura";

export default function Cobranza({ subSectionId }) {
  return (
    <div className="recent-sales overflow-auto">
      {subSectionId === SubSections.Dashboard && <CobranzaDashboard />}
      {subSectionId === SubSections.Metas && <CobranzaAsociados />}
      {subSectionId === SubSections.Conciliacion && <CobranzaConciliacion />}
      {subSectionId === SubSections.Reestructura && <CobranzaReestructura />}
    </div>
  );
}
